import { NotifyAlertType } from "../constants/constants";

export enum ExternalRefreshRequestStates {
	PENDING = 1,
	USER_REQUESTED = 2,
	COMPLETE = 3
}

export interface ExternalRefreshNotifierEmittedData {
	featureId: string; // must be understandable by the receiver
	data: any; // must be understandable by the receiver
}

export interface ExternalRefreshNotifierConfig {
	message: string; // translation key or string
	actionString: string; // translation key or string
	type: NotifyAlertType;
	emittedData: ExternalRefreshNotifierEmittedData; 
}

export interface ExternalRefreshUpdateData {
	state: ExternalRefreshRequestStates;
	details: ExternalRefreshNotifierEmittedData;
}
